import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "../api";
import Layout from "../components/Layout";
import { FaTrash, FaPlusCircle } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

const POS = () => {
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);

    const [orderId, setOrderId] = useState("");
    const [invoiceNo, setInvoiceNo] = useState("");

    const [selectedProductId, setSelectedProductId] = useState("");
    const [customer, setCustomer] = useState({ name: "", phone: "", address: "", state: "", gstNumber: "" });
    const [gstRate, setGstRate] = useState("");
    const [amountTendered, setAmountTendered] = useState("");

    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");

    const [showDue, setShowDue] = useState("inactive");
    const [editingOrderId, setEditingOrderId] = useState(null);

    const [cashAmount, setCashAmount] = useState("");
    const [upiAmount, setUpiAmount] = useState("");

    const [sellType, setSellType] = useState("quantity");

    const [existingOrderDue, setExistingOrderDue] = useState({
        previousDue: 0,
        currentDue: 0,
        dueAmount: 0
    });

    const location = useLocation();

    // Fetch products on load
    useEffect(() => {
        const fetchProducts = async () => {
            try {
                // PRODUCTS
                const res = await API.get("/products");
                setProducts(res.data);

                // CUSTOMERS
                const customerRes = await API.get("/customers");
                setCustomers(customerRes.data);

            } catch (err) { toast.error("Error loading products"); }
        };
        fetchProducts();
    }, []);

    useEffect(() => {

        if (location.state?.orderData) {

            const old = location.state.orderData;

            // EDIT MODE ID
            setEditingOrderId(old._id);

            // BASIC
            setOrderId(old.orderId || "");
            setInvoiceNo(old.invoiceNo || "");

            // CUSTOMER
            setCustomer({
                name: old.customer?.name || "",
                phone: old.customer?.phone || "",
                address: old.customer?.address || "",
                state: old.customer?.state || "",
                gstNumber: old.customer?.gstNumber || ""
            });

            // GST
            setGstRate(old.gstRate || 0);

            // PAYMENT
            setAmountTendered("");

            // DUE OPTION
            setShowDue(old.showDue || "inactive");

            setExistingOrderDue({
                previousDue: old.previousDue || 0,
                currentDue: old.currentDue || 0,
                dueAmount: old.dueAmount || 0
            });

            // CART
            const formattedCart = old.items.map((item) => {

                const product = products.find(
                    (p) => p._id === item.productId
                );

                return {
                    productId: item.productId,
                    name: item.name,
                    price: item.rate,
                    qty: item.qty,
                    stock: product?.quantity || 0
                };
            });

            setCart(formattedCart);
        }

    }, [location, products]);

    //////////////FIND CUSTOMER/////////////
    const handleCustomerChange = (e) => {

        const customerId = e.target.value;

        setSelectedCustomer(customerId);

        // FIND CUSTOMER
        const selected = customers.find(
            (c) => c._id === customerId
        );

        if (selected) {

            setCustomer({
                name: selected.name || "",
                phone: selected.phone || "",
                address: selected.address || "",
                state: selected.state || "",
                gstNumber: selected.gstNumber || ""
            });

        } else {

            setCustomer({
                name: "",
                phone: "",
                address: "",
                state: "",
                gstNumber: ""
            });
        }
    };

    // Explicit Add To Cart Handler
    const handleAddToCart = () => {

        if (!selectedProductId) {
            return toast.warning("Please select a product first");
        }
        if (!orderId || !invoiceNo) {
            return toast.error("Order ID & Invoice No. required");
        }
        const p = products.find(
            item => item._id === selectedProductId
        );

        if (!p) {
            return toast.error("Product not found");
        }

        const price =
            sellType === "kg"
                ? p.kgSellingPrice
                : p.quantitySellingPrice;

        const stock =
            sellType === "kg"
                ? p.kgStock
                : p.quantityStock;

        if (stock <= 0) {
            return toast.error("Out Of Stock");
        }

        const exists = cart.find(
            item =>
                item.productId === p._id &&
                item.sellType === sellType
        );

        if (exists) {

            setCart(
                cart.map(item =>

                    item.productId === p._id &&
                        item.sellType === sellType

                        ? {
                            ...item,
                            qty: item.qty + 1
                        }

                        : item
                )
            );

        } else {

            setCart([
                ...cart,
                {
                    productId: p._id,
                    name: p.name,
                    category: p.category,
                    sellType,
                    price,
                    stock,
                    qty: 1
                }
            ]);
        }

        toast.success(`${p.name} added to cart`);

        setSelectedProductId("");
    };

    // ================= CALCULATIONS =================
    // Subtotal
    const subTotal = cart.reduce((acc, item) => acc + (item.price * item.qty), 0);

    // GST Split
    const cgstRate = Number(gstRate) / 2;
    const sgstRate = Number(gstRate) / 2;

    // Tax Amounts
    const cgstAmount = (subTotal * cgstRate) / 100;
    const sgstAmount = (subTotal * sgstRate) / 100;

    // Total Tax
    const taxAmount = cgstAmount + sgstAmount;

    // Final Total
    const grandTotal = subTotal + taxAmount;

    // FINAL ROUND TOTAL
    const finalTotal = Math.ceil(grandTotal);

    // ROUND OFF VALUE
    const roundOff = Number(
        (finalTotal - grandTotal).toFixed(2)
    );

    // Payment
    const paidAmount = Number(amountTendered || 0);

    // Balance
    const balance = finalTotal - paidAmount;

    useEffect(() => {
        if (showDue === "inactive") {
            setAmountTendered(finalTotal.toString());
        }
    }, [showDue, finalTotal]);


    const handleGenerateInvoice = async () => {
        if (cart.length === 0) return toast.error("Cart is empty");



        const orderData = {
            orderId,
            invoiceNo,

            customerId: selectedCustomer,
            customer: {
                name: customer.name || "Guest",
                phone: customer.phone || "-",
                address: customer.address || "-",
                state: customer.state || "-",
                gstNumber: customer.gstNumber || "N/A"
            },
            items: cart.map(i => ({
                productId: i.productId,
                name: i.name,
                category: i.category,
                price: i.price,
                qty: i.qty,
                sellType: i.sellType
            })),
            subTotal,
            taxAmount,
            gstRate,
            cgst: cgstRate,
            sgst: sgstRate,
            cgstAmount,
            sgstAmount,
            grandTotal,
            finalTotal,
            amountTendered,
            showDue,
            cashAmount,
            upiAmount
        };

        try {

            let res;

            // UPDATE OLD DUE BILL
            if (editingOrderId) {
                res = await API.put(`/orders/${editingOrderId}`, {
                    amountTendered,
                    cashAmount,
                    upiAmount
                });


                toast.success("Due payment updated");

            }

            // CREATE NEW BILL
            else {

                res = await API.post(
                    "/orders",
                    orderData
                );

                toast.success(
                    `Invoice ${res.data.order.invoiceNo} Generated Successfully!`
                );
            }
            window.open(`/print-invoice/${res.data.order._id}`, "_blank");
            // RESET
            setCart([]);
            setOrderId("");
            setInvoiceNo("");
            setCustomer({ name: "", phone: "", address: "", state: "", gstNumber: "" });
            setAmountTendered("");
        } catch (err) { toast.error(err.response?.data?.message || "Checkout failed"); }
    };



    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={2000} />
            <div className="pos-container">

                <div className="card pos-header">
                    <div className="form-row">


                        <div className="input-group">
                            <label>Bill Option:</label>
                            <select
                                value={showDue}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setShowDue(value);

                                    if (value === "inactive") {
                                        setAmountTendered(finalTotal.toString());
                                    } else {
                                        setAmountTendered("");
                                    }
                                }}
                            >
                                <option value="inactive">Final Bill</option>
                                <option value="active">Duplicate Bill</option>
                            </select>
                        </div>

                        <div className="input-group">
                            <label>Order ID:</label>
                            <input
                                placeholder="ORD-1"
                                value={orderId}
                                onChange={e => setOrderId(e.target.value)}
                            />
                        </div>

                        <div className="input-group">
                            <label>Invoice No:</label>
                            <input
                                placeholder="INV-1"
                                value={invoiceNo}
                                onChange={e => setInvoiceNo(e.target.value)}
                            />
                        </div>

                        <div className="input-group">

                            <label>Select Customer Name:</label>

                            <select
                                value={selectedCustomer}
                                onChange={handleCustomerChange}
                            >

                                <option value="">
                                    Select Customer
                                </option>

                                {customers.map((c) => (

                                    <option
                                        key={c._id}
                                        value={c._id}
                                    >
                                        {c.name}
                                    </option>

                                ))}

                            </select>

                        </div>

                        <div className="input-group">
                            <label>Phone:</label>
                            <input
                                placeholder="0404040"
                                value={customer.phone}
                                onChange={e => setCustomer({ ...customer, phone: e.target.value })}
                            />
                        </div>
                        <div className="input-group">
                            <label>Address:</label>
                            <input
                                placeholder="address"
                                value={customer.address}
                                onChange={e => setCustomer({ ...customer, address: e.target.value })}
                            />
                        </div>
                        <div className="input-group">
                            <label>State:</label>
                            <input
                                value={customer.state}
                                onChange={e => setCustomer({ ...customer, state: e.target.value })}
                                placeholder="West Bengal"
                            />
                        </div>
                        <div className="input-group">
                            <label>GST Number:</label>
                            <input
                                placeholder="GST Number"
                                value={customer.gstNumber}
                                onChange={e =>
                                    setCustomer({
                                        ...customer,
                                        gstNumber: e.target.value
                                    })
                                }
                            />
                        </div>


                        <div className="input-group">
                            <label>Select Product » Category:</label>
                            <select
                                value={selectedProductId}
                                onChange={(e) => {
                                    const productId = e.target.value;
                                    setSelectedProductId(productId);

                                    const p = products.find(item => item._id === productId);

                                    if (p) {
                                        const hasQuantity = Number(p.quantityStock) > 0;
                                        const hasKg = Number(p.kgStock) > 0;

                                        if (hasQuantity && !hasKg) {
                                            setSellType("quantity");
                                        } else if (!hasQuantity && hasKg) {
                                            setSellType("kg");
                                        } else if (hasQuantity && hasKg) {
                                            setSellType("quantity");
                                        }
                                    }
                                }}
                            >
                                <option value="">Select Product » Category</option>
                                {products.map(p => (
                                    <option key={p._id} value={p._id}>
                                        {p.name} » {p.category || 'General'}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="input-group">
                            <label>Sell Type:</label>

                            <select
                                value={sellType}
                                onChange={(e) => setSellType(e.target.value)}
                                disabled={
                                    (() => {
                                        const p = products.find(item => item._id === selectedProductId);
                                        if (!p) return false;

                                        const hasQuantity = Number(p.quantityStock) > 0;
                                        const hasKg = Number(p.kgStock) > 0;

                                        return (hasQuantity && !hasKg) || (!hasQuantity && hasKg);
                                    })()
                                }
                            >
                                {(() => {
                                    const p = products.find(item => item._id === selectedProductId);

                                    if (!p) {
                                        return (
                                            <>
                                                <option value="quantity">Quantity</option>
                                                <option value="kg">KG</option>
                                            </>
                                        );
                                    }

                                    const hasQuantity = Number(p.quantityStock) > 0;
                                    const hasKg = Number(p.kgStock) > 0;

                                    return (
                                        <>
                                            {hasQuantity && <option value="quantity">Quantity</option>}
                                            {hasKg && <option value="kg">KG</option>}
                                        </>
                                    );
                                })()}
                            </select>
                        </div>

                    </div>

                    <button className="add-to-cart-btn" onClick={handleAddToCart}>
                        <FaPlusCircle /> Add To Cart
                    </button>
                </div>

                <div className="table-section mt-2">
                    <div className="table-responsive">
                        <table className="pos-cart-table">
                            <thead>
                                <tr><th>PRODUCT NAME</th><th>CATEGORY</th><th>Sell Type</th><th>STOCK</th><th>PRICE</th><th>QTY</th><th>SUBTOTAL</th><th>ACTION</th></tr>
                            </thead>
                            <tbody>
                                {cart.map(item => (
                                    <tr key={item.productId +
                                        item.sellType}>
                                        <td>{item.name}</td>
                                        <td>{item.category || "General"}</td>
                                        <td>

                                            {item.sellType === "kg"

                                                ? "KG"

                                                : "Quantity"}

                                        </td>
                                        <td><span className="badge-green">{item.stock} In Stock</span></td>

                                        <td>
                                            <input
                                                type="number"
                                                className="table-input"
                                                value={item.price.toFixed(2)}
                                                readOnly
                                            />
                                        </td>
                                        {/* Editable QTY Input */}
                                        <td>

                                            <input
                                                type="number"
                                                className="table-input"

                                                value={item.qty}

                                                min="0.1"

                                                step={
                                                    item.sellType === "kg"
                                                        ? "0.1"
                                                        : "1"
                                                }

                                                onChange={(e) => {

                                                    const newQty =
                                                        Number(
                                                            e.target.value
                                                        );

                                                    if (
                                                        newQty >
                                                        item.stock
                                                    ) {

                                                        return toast.error(
                                                            "Exceeds Stock"
                                                        );
                                                    }

                                                    setCart(

                                                        cart.map(i =>

                                                            i.productId === item.productId &&
                                                                i.sellType === item.sellType

                                                                ? {
                                                                    ...i,
                                                                    qty: newQty
                                                                }

                                                                : i
                                                        )
                                                    );
                                                }}
                                            />

                                        </td>
                                        {/* Dynamic SUBTOTAL Input */}
                                        <td>
                                            <input
                                                type="number"
                                                className="table-input subtotal-input"
                                                value={(item.price * item.qty).toFixed(2)}
                                                readOnly
                                            />
                                        </td>
                                        <td>

                                            <button
                                                className="delete-btn"

                                                onClick={() =>

                                                    setCart(

                                                        cart.filter(i =>

                                                            !(
                                                                i.productId === item.productId &&
                                                                i.sellType === item.sellType
                                                            )
                                                        )
                                                    )
                                                }
                                            >

                                                <FaTrash />

                                            </button>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="pos-footer card mt-2">
                    <div className="billing-summary">

                        <div className="bill-row">
                            <span>Sub Total</span>
                            <input value={subTotal.toFixed(2)} readOnly />
                        </div>

                        <div className="bill-row">
                            <span>GST Tax %</span>
                            <input
                                type="text"
                                value={gstRate}
                                onChange={(e) =>
                                    setGstRate(String(e.target.value))
                                }
                            />
                        </div>

                        <div className="bill-row">
                            <span>CGST ({cgstRate}%)</span>
                            <input
                                value={cgstAmount.toFixed(2)}
                                readOnly
                            />
                        </div>

                        <div className="bill-row">
                            <span>SGST ({sgstRate}%)</span>
                            <input
                                value={sgstAmount.toFixed(2)}
                                readOnly
                            />
                        </div>

                        <div className="bill-row">
                            <span>Total GST</span>
                            <input
                                value={taxAmount.toFixed(2)}
                                readOnly
                            />
                        </div>

                        <div className="bill-row">
                            <span>Grand Total</span>
                            <input
                                value={grandTotal.toFixed(2)}
                                readOnly
                            />
                        </div>

                        <div className="bill-row">
                            <span>Round Off</span>
                            <input
                                value={roundOff.toFixed(2)}
                                readOnly
                            />
                        </div>

                        <div className="bill-row">
                            <span>Final Amount</span>
                            <input
                                value={finalTotal.toFixed(2)}
                                readOnly
                            />
                        </div>


                        <div className="bill-row">
                            <span>{editingOrderId ? "Pay Now" : "Paid Amount"}</span>
                            <input
                                type="text"
                                value={amountTendered}
                                onChange={(e) => setAmountTendered(String(e.target.value))}
                                readOnly={showDue === "inactive"}
                            />
                        </div>


                        {showDue === "active" && (
                            <div className="bill-row">
                                <span>{editingOrderId ? "Total Due" : "Due Balance"}</span>
                                <input
                                    value={
                                        editingOrderId
                                            ? (existingOrderDue.dueAmount - paidAmount).toFixed(2)
                                            : balance.toFixed(2)
                                    }
                                    readOnly
                                />
                            </div>
                        )}

                        <div className="bill-row">
                            <span>Cash</span>
                            <input
                                type="text"
                                value={cashAmount}
                                onChange={(e) =>
                                    setCashAmount(String(e.target.value))
                                }
                            />
                        </div>

                        <div className="bill-row">
                            <span>UPI</span>
                            <input
                                type="text"
                                value={upiAmount}
                                onChange={(e) =>
                                    setUpiAmount(String(e.target.value))
                                }
                            />
                        </div>

                    </div>
                    <button className="generate-btn" onClick={handleGenerateInvoice}>Generate Invoice</button>
                </div>
            </div>
        </Layout>
    );
};

export default POS;

